// Page displaying list of metadata items
import {initCore} from 'src/lib/init.js'
import renderComponents from 'src/lib/render-components.js'
import MetadataList from "@/browse/MetadataList.vue"
import 'src/styles/taggle.css'
import 'src/styles/aristotle.less'
import 'src/styles/aristotle.table_browser.less'
import Collection from '@/collection/Collection.vue'
import apolloProvider from 'src/lib/graphql/vue-apollo'
import router from 'src/router/router'
import Vue from 'vue'

initCore()
renderComponents({'collection': Collection})

let root = {
    el: '#vue-container',
    apolloProvider,
    router,
    components: {MetadataList}
}
new Vue(root)
